export const reportsFa: Record<string, string> = {
  'nav.dashboard': 'داشبورد',
  'rp.title': 'داشبورد',
  'rp.sub':
    'وضعیت مرکز در ماه‌های انتخاب‌شده — فعالیت، پول، مراجعان و مرخصی. فقط جمع‌ها؛ هیچ مراجعی این‌جا نام برده نمی‌شود.',
  'rp.range.label': 'دوره',
  'rp.range.3m': '۳ ماه',
  'rp.range.6m': '۶ ماه',
  'rp.range.12m': '۱۲ ماه',
  'rp.range.year': 'امسال',
  'rp.range.custom': 'دلخواه',
  'rp.range.from': 'از ماه',
  'rp.range.to': 'تا ماه',
  'rp.range.apply': 'نمایش',
  'rp.range.order': 'ماه اول نباید بعد از ماه آخر باشد.',
  'rp.range.tooWide': 'یک دوره حداکثر {max, number} ماه را پوشش می‌دهد.',
  'rp.range.showing': '{from} – {to}',
  'rp.fresh': 'ارقام تا {time}',
  'rp.fresh.patients': 'ارقام مراجعان تا {time}',
  'rp.export.cta': 'خروجی برای اکسل',
  'rp.export.title': 'کلینیک زویار — داشبورد',
  'rp.export.window': 'دوره',
  'rp.export.generated': 'ارقام تا',
  'rp.export.figure': 'شاخص',
  'rp.export.value': 'مقدار',
  'rp.export.patients': 'مراجعان',
  'rp.failedTitle': 'داشبورد بارگذاری نشد',
  'rp.failedBody': 'به‌جای چیزی کهنه، هیچ‌چیز نشان داده نمی‌شود. کمی بعد دوباره تلاش کنید.',
  'rp.retry': 'تلاش دوباره',
  'rp.empty': 'در دوره انتخاب‌شده چیزی نیست.',
  'rp.sortBy': 'مرتب‌سازی بر اساس {col}',
  'rp.sortedAsc': 'مرتب شده صعودی',
  'rp.sortedDesc': 'مرتب شده نزولی',
  'rp.wholePeriod': 'کل دوره',
  'rp.month': 'ماه',

  'rp.now.title': 'همین حالا',
  'rp.now.note': 'تا همین حالا — به ماه‌های انتخاب‌شده گره نخورده.',
  'rp.now.debt': 'بدهی',
  'rp.now.credit': 'اعتبار',
  'rp.now.debtPatients':
    '{n, plural, =0 {هیچ مراجعی بدهکار نیست} one {# مراجع بدهکار است} other {# مراجع بدهکارند}}',
  'rp.now.creditPatients':
    '{n, plural, =0 {هیچ مراجعی اعتبار ندارد} one {# مراجع اعتبار دارد} other {# مراجع اعتبار دارند}}',
  'rp.now.drafts': 'پیش‌نویس‌های ارزیابی در جریان',
  'rp.now.balances': 'ماندهٔ بیماران',

  'rp.g.activity': 'فعالیت',
  'rp.g.money': 'پول',
  'rp.g.growth': 'مراجعان و ارزیابی‌ها',
  'rp.g.capacity': 'مرخصی',

  'rp.svc.title': 'جلسات برگزار شده به تفکیک خدمت',
  'rp.svc.sub': 'جلسات برگزار شده در هر ماه؛ هر شرکت‌کننده یک جلسه گروهی این‌جا حساب می‌شود.',
  'rp.svc.other': 'خدمات دیگر',
  'rp.svc.filter': 'خدمت',
  'rp.svc.all': 'همه خدمات',
  'rp.paid.note':
    '«پرداخت‌شده تا حالا» همان چیزی است که تا حالا بابت این جلسات پرداخت‌شده. ممکن است با پرداخت جلسات قبلی باز هم بالا برود — رقم نهایی نیست.',

  'rp.pr.title': 'جلسات به تفکیک درمانگر',
  'rp.pr.sub': 'حجم جلسات برای برنامه‌ریزی. یک جلسه گروهی یک‌بار برای درمانگرش حساب می‌شود.',
  'rp.pr.note': 'یک جلسه گروهی یک‌بار حساب می‌شود، هر چند نفر که شرکت کرده باشند.',

  'rp.cx.title': 'لغوها و غیبت‌ها',
  'rp.cx.sub':
    'شمارش بر اساس ماهی که جلسه برای آن زمان‌بندی شده بود. لغو شده و غیبت جدا نگه داشته می‌شوند.',
  'rp.cx.note': 'فقط شمارش، بر اساس ماه زمان‌بندی.',
  'rp.cx.byPractitioner': 'لغوها و غیبت‌ها به تفکیک درمانگر',
  'rp.cx.pickMonth': 'برای دیدن نوبت‌ها در تقویم، یک ماه را انتخاب کنید.',
  'rp.cx.openCancelled': 'باز کردن نوبت‌های لغوشدهٔ {name} در تقویم',
  'rp.cx.openNoShow': 'باز کردن غیبت‌های {name} در تقویم',

  'rp.fin.chargedTitle': 'مبلغ جلسه‌ها و پرداخت‌شده تا امروز',
  'rp.fin.chargedSub': 'جلسات برگزار شده چقدر هزینه شده‌اند، و چه مقدارش تا حالا پرداخت‌شده.',
  'rp.fin.collectedTitle': 'دریافت‌شده به تفکیک روش',
  'rp.fin.collectedSub': 'پرداخت‌های دریافت‌شده در هر ماه، بر اساس ماهی که دریافت‌شده‌اند.',
  'rp.fin.reversedNote':
    'پرداخت‌های برگشتی جدا گفته می‌شوند و هیچ‌وقت از آنچه دریافت‌شده کم نمی‌شوند.',
  'rp.fin.history': 'پرداخت‌ها',
  'rp.fin.historyOf': 'باز کردن پرداخت‌های دریافت‌شده در {month}',
  'rp.fin.totalCharged': 'مبلغ جلسه‌ها',
  'rp.fin.totalPaid': 'پرداخت‌شده تا امروز',
  'rp.fin.totalCollected': 'دریافت‌شده',
  'rp.fin.totalReversed': 'برگشت شده',

  'rp.pt.title': 'تماس‌های جدید و ثبت‌نام‌ها',
  'rp.pt.sub':
    'افرادی که هر ماه برای اولین بار ثبت‌شده‌اند، به تفکیک آنچه امروز هستند، کنار ثبت‌نام‌های کامل‌شده همان ماه.',
  'rp.pt.note':
    '«هنوز مهمان» وضعیت امروز است: ماه‌های اخیر فرصت کمتری برای ثبت‌نام داشته‌اند، بنابراین ماه‌ها به‌عنوان نرخ قابل مقایسه نیستند.',
  'rp.pt.totalRegistered': 'مراجعان ثبت‌شده (کل زمان)',
  'rp.pt.totalGuests': 'مهمان‌ها (کل زمان)',

  'rp.as.title': 'ارزیابی‌ها',
  'rp.as.sub':
    'ارزیابی‌های کامل‌شده در هر ماه، به تفکیک این‌که بسته‌ای از آن‌ها ساخته‌شده یا نه، و پیش‌نویس‌های شروع‌شده همان ماه که هنوز پیش‌نویس‌اند.',

  'rp.to.title': 'مرخصی درمانگر',
  'rp.to.sub': 'هر مورد مرخصی در دوره، با ساعتش.',
  'rp.to.truncated':
    'این فهرست کوتاه شده: دوره موارد مرخصی بیشتری از آنچه یک‌جا فهرست شود دارد، و جدیدترین‌ها غایب اند. دوره کوتاه‌تری انتخاب کنید تا همه را ببینید.',
  'rp.to.filter': 'درمانگر',
  'rp.to.all': 'همه درمانگران',
  'rp.to.total': '{hours} ساعت در {n, plural, one {# مورد} other {# مورد}}',
  'rp.to.reasonShow': 'نمایش دلیل',
  'rp.to.reasonHide': 'پنهان کردن دلیل',
  'rp.to.reasonOf': 'دلیل مرخصی {name} در {date}',
  'rp.to.noReason': 'هیچ دلیلی ثبت‌نشده.',
  'rp.to.availability': 'دسترس‌پذیری',

  'rp.col.month': 'ماه',
  'rp.col.service': 'خدمت',
  'rp.col.sessions': 'جلسه‌ها',
  'rp.col.charged': 'مبلغ جلسه‌ها',
  'rp.col.paid': 'پرداخت‌شده تا امروز',
  'rp.col.paidPct': 'درصد پرداخت‌شده تا حالا',
  'rp.col.practitioner': 'درمانگر',
  'rp.col.individual': 'جلسات فردی',
  'rp.col.group': 'جلسه‌های گروهی',
  'rp.col.total': 'جمع',
  'rp.col.cancelled': 'لغو شده',
  'rp.col.noShow': 'غیبت',
  'rp.col.collected': 'دریافت‌شده',
  'rp.col.payments': 'پرداخت‌ها',
  'rp.col.reversed': 'برگشت شده',
  'rp.col.reversedCount': 'پرداخت‌های برگشتی',
  'rp.col.newContacts': 'تماس‌های جدید',
  'rp.col.registeredNow': 'اکنون ثبت‌شده',
  'rp.col.stillGuests': 'هنوز مهمان',
  'rp.col.registrations': 'ثبت‌نام‌ها',
  'rp.col.completed': 'کامل‌شده',
  'rp.col.linked': 'پیوند شده به بسته',
  'rp.col.notLinked': 'پیوند نشده',
  'rp.col.drafts': 'پیش‌نویس‌های شروع‌شده',
  'rp.col.date': 'تاریخ',
  'rp.col.dateGregorian': 'تاریخ (میلادی)',
  'rp.col.hours': 'ساعت‌ها',

  'perm.clinic.reports.read': 'دیدن داشبورد مدیریتی',
  'perm.clinic.reports.read.desc':
    'داشبورد را باز می‌کند: جمع‌های سراسری مرکز برای جلسات، پول، مراجعان، ارزیابی‌ها، لغوها و مرخصی. هیچ مراجعی نام برده نمی‌شود؛ باز کردن صفحه‌های سطح مراجع همچنان به مجوزهای خودشان نیاز دارد.',

  'rp.g.feedback': 'بازخورد خانواده‌ها',
  'rp.fb.title': 'بازخورد خانواده به تفکیک درمانگر',
  'rp.fb.sub': 'امتیازها از ۱ تا ۵ است. یک درمانگر انتخاب کنید تا بازخورد را بخوانید.',
  'rp.fb.totals': '{responses} پاسخ · میانگین کلی {avg} · نرخ پاسخ {rate}',
  'rp.fb.none': 'در این دوره هنوز بازخوردی نیست.',
  'rp.fb.col.responses': 'پاسخ‌ها',
  'rp.fb.col.rate': 'نرخ پاسخ',
  'rp.fb.col.avg': 'میانگین',
  'rp.fb.q.overall': 'رضایت کلی',
  'rp.fb.q.manner': 'رفتار و توجه',
  'rp.fb.q.clarity': 'شفافیت توضیح',
  'rp.fb.q.punctuality': 'وقت‌شناسی',
  'rp.fb.from': 'از {n} پاسخ',
  'rp.fb.rateOf': '{responses} پاسخ از {eligible} جلسه',
  'rp.fb.unnamed': 'بی‌نام',
  'rp.fb.listTitle': 'بازخورد برای {name}',
  'rp.fb.listAll': 'همه بازخوردها',
  'rp.fb.back': 'بستن فهرست',
  'rp.fb.onlyComments': 'فقط با نظر',
  'rp.fb.col.date': 'تاریخ جلسه',
  'rp.fb.col.patient': 'مراجع',
  'rp.fb.col.service': 'خدمت',
  'rp.fb.col.score': 'کلی',
  'rp.fb.col.comment': 'نظر',
  'rp.fb.noComment': 'بدون نظر',
  'rp.fb.listEmpty': 'هیچ بازخوردی مطابقت ندارد.',
  'rp.fb.open': 'باز کردن بازخورد',
  'rp.fb.sheet.title': 'بازخورد خانواده',
  'rp.fb.sheet.close': 'بستن',
  'rp.fb.sheet.by': 'داده‌شده توسط',
  'rp.fb.sheet.patient': 'مراجع',
  'rp.fb.sheet.record': 'پرونده {n}',
  'rp.fb.sheet.openPatient': 'باز کردن پرونده مراجع',
  'rp.fb.sheet.session': 'جلسه',
  'rp.fb.sheet.therapist': 'درمانگر',
  'rp.fb.sheet.submitted': 'ارسال شده',
  'rp.fb.sheet.comment': 'نظر',
  'rp.fb.sheet.voided': 'این جلسه بعدا باطل شد؛ بازخوردش در ارقام حساب نمی‌شود.',
  'rp.fb.sheet.failed': 'این بازخورد بارگذاری نشد.',
  'rp.fb.outOf': '{n} از ۵',

  'perm.clinic.feedback.read': 'دیدن بازخورد خانواده‌ها',
  'perm.clinic.feedback.read.desc':
    'آنچه خانواده‌ها درباره جلسات گفته‌اند را در داشبورد نشان می‌دهد: یک خلاصه برای هر درمانگر و هر بازخورد با نام مراجع و عضو خانواده. فقط به کسی بدهید که این‌ها را پیگیری می‌کند؛ دسترسی داشبورد هم لازم است.',

  'rp.g.endings': 'ترک درمان و ترخیص',
  'rp.te.title': 'ترک درمان و ترخیص به تفکیک ماه',
  'rp.te.sub': 'فقط پرونده‌های نهایی. ترخیص جدا از ترک درمان حساب می‌شود.',
  'rp.te.dropouts': 'ترک درمان',
  'rp.te.discharges': 'ترخیص',
  'rp.te.returns': 'بازگشت',
  'rp.te.totals': '{dropouts} ترک درمان · {discharges} ترخیص · {returns} بازگشت',
  'rp.te.pending': '{n} در انتظار تسویه — هنوز حساب نمی‌شود.',
  'rp.te.none': 'در این دوره هیچ ترک درمان یا ترخیصی نهایی نشد.',
  'rp.te.rate': 'نرخ ترک درمان',
  'rp.te.rateHelp': '{dropouts} ترک درمان از {active} مراجع دارای جلسه',
  'rp.te.reasonTitle': 'دلایل ترک درمان',
  'rp.te.col.reason': 'دلیل',
  'rp.te.col.count': 'تعداد',
  'rp.te.col.month': 'ماه',
  'rp.te.practitionerTitle': 'به تفکیک درمانگر',
  'rp.te.serviceTitle': 'به تفکیک خدمت',
  'rp.te.col.service': 'خدمت',
  'rp.te.sessionsTitle': 'ترک درمان بعد از چند جلسه',
  'rp.te.col.sessions': 'جلسات برگزار شده',
  'rp.te.originTitle': 'چه زمانی ترک کردند',
  'rp.te.origin.mid_course': 'در میانه دوره',
  'rp.te.origin.not_continued': 'بعد از دوره ادامه ندادند',
  'rp.te.unknown': 'نامشخص',
  // ZOY-776: extra charges.
  'rp.xc.title': 'هزینه‌های اضافی',
  'rp.xc.sub':
    'هزینه‌های کنار جلسات به تفکیک نوع — تعداد، مبلغ، پرداخت‌شده تا حالا، دقیقه و موارد خارج از پیش‌فرض (یک علامت، نه تایید).',
  'rp.xc.note': 'خارج از پیش‌فرض = مبلغ با پیش‌فرض آن نوع فرق داشت، یا آن نوع مبلغ آزاد داشت.',
  'rp.col.kind': 'نوع',
  'rp.col.count': 'تعداد',
  'rp.col.minutes': 'دقیقه',
  'rp.col.flagged': 'خارج از نرخ',
  'rp.col.extraMinutes': 'دقیقه‌های اضافی',
  'rp.pr.extraNote':
    '«دقیقه‌های اضافی» دقیقه‌های هزینه‌های اضافی ای است که نوعشان به‌عنوان زمان کار درمانگر حساب می‌شود.',
};
